import { environment } from '../../../../environments/environment'
import { type CartoClient } from '../../ooh/services/carto.helper'

export interface CampaignDemographicsRow {
  nvisitors_gender_m: number
  nvisitors_gender_f: number
  nvisitors_gender_unknown: number
  nvisitors_age_18_24: number
  nvisitors_age_25_34: number
  nvisitors_age_35_44: number
  nvisitors_age_45_54: number
  nvisitors_age_55_64: number
  nvisitors_age_65_100: number
  nvisitors_age_unknown: number
  nvisitors_visitor_profile_local: number
  nvisitors_visitor_profile_regional: number
  nvisitors_visitor_profile_national: number
  nvisitors_visitor_profile_international: number
  nvisitors_visitor_profile_resident: number
  nvisitors_visitor_profile_commuter: number
  nvisitors_visitor_profile_unknown: number
}

export interface CampaignDemographicsFilters {
  delivery_id: number
  delivery_start_date: string
  filter_combined: string
}

export async function fetchCampaignDemographics(
  cartoClient: CartoClient,
  filters: CampaignDemographicsFilters,
  signal?: AbortSignal,
): Promise<CampaignDemographicsRow | null> {
  const { delivery_id, delivery_start_date, filter_combined } = filters
  const response = await cartoClient.query<CampaignDemographicsRow>({
    source: {
      source: `${environment.CARTO_SOURCE_PREFIX}_campaigns_demographics`,
      queryParameters: {
        delivery_id,
        delivery_start_date,
        filter_combined,
      },
    },
    params: {
      column: [
        'nvisitors_gender_m',
        'nvisitors_gender_f',
        'nvisitors_gender_unknown',
        'nvisitors_age_18_24',
        'nvisitors_age_25_34',
        'nvisitors_age_35_44',
        'nvisitors_age_45_54',
        'nvisitors_age_55_64',
        'nvisitors_age_65_100',
        'nvisitors_age_unknown',
        'nvisitors_visitor_profile_local',
        'nvisitors_visitor_profile_regional',
        'nvisitors_visitor_profile_national',
        'nvisitors_visitor_profile_international',
        'nvisitors_visitor_profile_resident',
        'nvisitors_visitor_profile_commuter',
        'nvisitors_visitor_profile_unknown',
      ],
    },
    signal,
  })

  return response?.rows?.[0] ?? null
}
